import State from "/WebInterface/new-ui/store/state.js";
import { sortingOrder } from "/WebInterface/new-ui/assets/js/constants.js";

const defaultSortingStatus = {
  active: null,
  created: {
    type: "date",
    order: sortingOrder?.ASC,
    field: "createdMillis",
  },
  expires: {
    type: "date",
    order: sortingOrder?.ASC,
    field: "expireMillis",
  },
  to: {
    type: "string",
    order: sortingOrder?.ASC,
    field: "emailTo_formatted",
  },
  paths: {
    type: "string",
    order: sortingOrder?.ASC,
    field: "paths",
  },
  remainingUses: {
    type: "number",
    order: sortingOrder?.ASC,
    field: "login_allowance",
  },
  comments: {
    type: "string",
    order: sortingOrder?.ASC,
    field: "comments_formatted",
  },
};

// Define the initial state of the store
const initialState = {
  shareList: [],
  initShareList: [],
  sortingStatus: defaultSortingStatus,
};

// Create a new instance of the State class with initial state and empty actions, subscriptions, and history
const store = new State({ actions: {}, subscriptions: [], history: [] });

// Initialize the store with the initial state
Object.keys(initialState).forEach((key) => {
  if (!(key in store)) {
    store[key] = initialState[key];
  }
});

store.setManageSharesList = (data = { payload: {} }) => {
  const files = data.payload;
  store.shareList = [...files];
  store.initShareList = [...files];
  store.sortingStatus = utils.deepCopy(defaultSortingStatus);
};

store.toggleCheckAll = (data = { payload: {} }) => {
  const checked = data?.payload?.checked;

  const shareList = store.shareList;
  store.shareList = shareList.map((item) => {
    return {
      ...item,
      checked,
    };
  });
};

store.toggleCheck = (data = { payload: {} }) => {
  const checked = data?.payload?.checked;
  const itemId = data?.payload?.itemId;

  const shareList = store.shareList;
  store.shareList = shareList.map((item) => {
    if (item?.id !== itemId) return item;
    return {
      ...item,
      checked,
    };
  });
};

store.searchItemsByValue = (data = { payload: {} }) => {
  const searchedValue = data?.payload?.value;

  if (!searchedValue) {
    store.shareList = store.initShareList;
    return;
  }

  const initShareList = store.initShareList;
  const filteredList = initShareList.filter((item) => {
    const searchFields = [
      item?.created,
      item?.expire,
      item?.emailTo_formatted,
      item?.paths,
      item?.login_allowance_formatted,
      item?.comments_formatted,
    ];

    const valueFound = searchFields.find((field) =>
      field?.toLowerCase().includes(searchedValue?.toLowerCase())
    );
    return valueFound;
  });

  const sortingStatus = store.sortingStatus;
  const sortField = sortingStatus.active;

  if (sortField) {
    const currentSortingStatus = sortingStatus[sortField];

    const sortedShareList = utils.sortListing({
      payload: {
        fieldName: currentSortingStatus?.field,
        order:
          currentSortingStatus?.order === sortingOrder?.DES
            ? sortingOrder?.ASC
            : sortingOrder?.DES,
        type: currentSortingStatus?.type,
        files: filteredList,
      },
    });

    store.shareList = sortedShareList;
    return;
  }

  store.shareList = filteredList;
};

store.sortShareList = (data = { payload: {} }) => {
  const sortField = data?.payload?.sortField;

  const sortingStatus = store.sortingStatus;
  const shareList = store.shareList;

  const currentSortingStatus = sortingStatus[sortField];

  const sortedShareList = utils.sortListing({
    payload: {
      fieldName: currentSortingStatus?.field,
      order: currentSortingStatus?.order,
      type: currentSortingStatus?.type,
      files: shareList,
    },
  });

  const order = currentSortingStatus?.order;

  sortingStatus.active = sortField;
  sortingStatus[sortField].order =
    order === sortingOrder?.DES ? sortingOrder?.ASC : sortingOrder?.DES;
  store.shareList = sortedShareList;
};

store.selectItemsWithSameKeyValuePair = (data = { payload: {} }) => {
  const selectedItems = data?.payload;
  store.shareList = [...selectedItems];
};

export default store;
